import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { gsap } from 'gsap';
import { md, lg, xl, wide, xwide } from '../common';

export function initBlockCard02(parent) {
  if (!parent) return;

  const swiper = parent.querySelector('.swiper');

  new Swiper(swiper, {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      [md]: { slidesPerView: 2, spaceBetween: 20 },
      [lg]: { slidesPerView: 3, spaceBetween: 20 },
      [wide]: { slidesPerView: 3, spaceBetween: 24 },
      [xwide]: { slidesPerView: 3, spaceBetween: 32 },
    },
  });

  const cards = parent.querySelectorAll('.block-card-02__card');
  cards.forEach((card, index) => {
    card.addEventListener('click', () => {
      card.classList.toggle('is-active');
    });

    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });
    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initBlockCard02s() {
  const blocks = document.querySelectorAll('.block-card-02');
  blocks.forEach((block) => initBlockCard02(block));
}
